import React from 'react';
import ReactDOM from 'react-dom/client';
import emailjs from '@emailjs/browser';
import './index.scss';
import './index-768px.scss';
import './index-480px.scss';
import './reset-hover-on-mobile.scss'
import App from './App';
import { initializeTheme } from './theme';

// Initialize theme
initializeTheme();

// Initialize EmailJS
emailjs.init({
  publicKey: import.meta.env.VITE_EMAILJS_PUBLIC_KEY,
});

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
